export const ratingExpressions = {
    0: "",
    1: "Yikes! We missed the mark",
    2: "Close, but not quite there!",
    3: "We’re good, But we’re aiming for greatness",
    4: "We’re almost perfect-thanks for the love!",
    5: "Fantastic! You’ve just made our day!"
  };